import { axios } from 'src/api'
import {
  ApiSaveDataRateParams,
  ApiSaveDataRateResponse
} from './savedatarate.types'

export const apiSaveDataRate = async ({
  serverPath,
  data
}: ApiSaveDataRateParams) => {
  const response = await axios.post<ApiSaveDataRateResponse>(
    `https://${serverPath}/sialdPMS/web/resourcescrossorigin/seasonmanual/savedatarate`,
    data
  )

  return response.data
}
